import { z } from 'zod';

const StateProvSchema = z.object({
  code: z.string(),
  display: z.string(),
});

const CountrySchema = z.object({
  code: z.string(),
  display: z.string(),
  show_state_provs: z.boolean(),
  state_prov_label: z.string().nullable(),
  state_provs: z.array(StateProvSchema),
  show_tax_exemption_number: z.boolean(),
  tax_exemption_type: z.string().nullable(),
  tax_exemption_label: z.string().nullable(),
  show_tax_exemption_agreement: z.boolean(),
  tax_exemption_disclaimer: z.string().nullable(),
});

export const CountriesResponseSchema = z.object({
  countries: z.array(CountrySchema),
});

export type StateProv = z.infer<typeof StateProvSchema>;

export type Country = z.infer<typeof CountrySchema>;

export type CountriesResponse = z.infer<typeof CountriesResponseSchema>;
